import { FixedSeries } from './';
import { RemoteMixin } from '../RemoteMixin';

export class RemoteFixedSeries extends RemoteMixin(FixedSeries) { }